import React, { Component } from 'react'
import { API_ROOT } from '../../../baseUrls'
import { withStyles } from "@mui/styles";
import { connect } from 'react-redux'
import { updateMindfileGroup } from '../../../state/actions/updateDataActions'
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
} from '@mui/material';
import Alert from '@mui/material/Alert'

const styles = () => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  }
})

class MultiUser extends Component {
  constructor(props) {
    super(props)
    this.state = {
      multiUserMode: 'display',
      showPrivacySuccessMessage: false,
    }
  }

  updatePrivacy() {
    const formData = new FormData()
    formData.append("mindfile[privacy_level]", this.props.mindfile.privacy_level)
    formData.append("mindfile[group]", this.props.mindfile.group)
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${ API_ROOT }/mindfiles/${ this.props.mindfile.id }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.setState({
          multiUserMode: 'display',
          showPrivacySuccessMessage: true,
        })
      }
    })
    .catch(error => console.error(error))
  }

  renderMultiUserDisplay() {
    return (
      <Box>
        { this.state.showPrivacySuccessMessage ?<Box style={{marginBottom: "1rem"}}> <Alert onClose={ () => this.setState({ showPrivacySuccessMessage: false }) }>Multi-user option was updated.</Alert></Box> : '' }
        <Box sx={{ display: { xs: 'block', md: 'none' } }} pb={2}><Typography>Multi-user</Typography></Box>
        <div style={{display:"flex", gap:"0.5rem"}}>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}><Typography>Multi-user</Typography></Box>
          <Box display="flex" flexGrow={1} justifyContent="center"><Typography>{ this.props.mindfile.group ? 'Yes' : 'No' }</Typography></Box>
          <Button variant="contained" color="primary" onClick={ () => this.setState({ multiUserMode: 'form' }) }>Update</Button>
        </div>
      </Box>
    )
  }

  renderMultiUserForm(classes) {
    return (
      <Box>
        <Typography className={classes.cardTitle} variant="subtitle1" gutterBottom>
          Multi-user
        </Typography>
        <Box className={ classes.fieldWrapper }>
          <FormControl component="fieldset">
            <RadioGroup
              name="multi-user"
              value={ this.props.mindfile.group ? 'yes' : 'no' }
              onChange={ (evt) => this.props.updateMindfileGroup(evt.target.value === "yes") }
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box className={ classes.buttonWrapper }>
          <Button variant="contained" color="primary" onClick={ this.updatePrivacy.bind(this) }>Update</Button>
          <Button style={{ marginLeft: 8 }} variant="contained" color="primary" onClick={ () => this.setState({ multiUserMode: 'display' }) }>Cancel</Button>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props
    return (this.state.multiUserMode === 'display') ? this.renderMultiUserDisplay(classes) : this.renderMultiUserForm(classes)
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
}

const mapDispatchToProps = {
  updateMindfileGroup,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MultiUser))
